import { observer } from 'mobx-react';
import { Avatar, Checkbox, Dropdown, Modal, Typography } from 'antd';
import { Briefcase, List } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router';
import styles from './index.module.scss';
import userStore from '../../../../stores/userStore';
import themeStore from '../../../../stores/themeStore';

interface Props {
  isCollapsed: boolean;
  onToggleSidebar: () => void;
}

const Header = observer(({ isCollapsed, onToggleSidebar }: Props) => {
  return (
    <div className={styles.top}>
      <div className={styles.topHeader}>
        <div
          onClick={onToggleSidebar}
          className={styles.collapse}
          style={{ transform: isCollapsed ? 'rotate(90deg)' : 'rotate(0deg)' }}
        >
          <List />
        </div>
        <LogoMobile />
        <div className={styles.trailing}>
          <User />
        </div>
      </div>
    </div>
  );
});

export default Header;

const LogoMobile = observer(() => {
  const nav = useNavigate();

  return (
    <div onClick={() => nav('/projects')} className={styles.logoMobile}>
      Stafflow <span className={styles.numberSm}>360</span>
    </div>
  );
});

const User = observer(() => {
  const nav = useNavigate();

  const onLogout = () => {
    Modal.confirm({
      title: 'Вы уверены что хотите выйти?',
      okText: 'Выйти',
      onOk: () => {
        localStorage.removeItem('token360');
        window.location.reload();
      },
    });
  };

  const onToggleTheme = () => themeStore.toggle();

  const fullName = [userStore.user?.firstName, userStore.user?.lastName].filter(Boolean).join(' ');

  return (
    <Dropdown
      trigger={['click']}
      popupRender={() => (
        <div className={styles.menu}>
          <div className={styles.name}>
            <Avatar className={styles.avatar} src={userStore.user?.logo ?? userStore.user?.avatar}>
              {!userStore.user?.logo && !userStore.user?.avatar && <Briefcase />}
            </Avatar>
            <div>
              <div className={styles.userName}>{fullName || 'Профиль'}</div>
              <Typography.Text ellipsis={{ tooltip: true }} className={styles.userEmail}>
                {userStore.user?.isHost ? 'Администратор' : 'Пользователь'}
              </Typography.Text>
            </div>
          </div>
          <div onClick={() => nav('/profile')} className={styles.option}>
            Личный кабинет
          </div>
          <div className={styles.option} onClick={onToggleTheme}>
            <div>Тёмная тема</div>
            <Checkbox checked={themeStore.isDark} style={{ marginRight: 12 }} />
          </div>
          <div onClick={onLogout} className={styles.option}>
            Выйти
          </div>
        </div>
      )}
    >
      <Avatar className={styles.avatarMain} src={userStore.user?.logo ?? userStore.user?.avatar}>
        {!userStore.user?.logo && !userStore.user?.avatar && <Briefcase />}
      </Avatar>
    </Dropdown>
  );
});
